import request from '@/utils/request'

let CocApi = {

  /*商会会员列表*/
  list(data) {
    return request._post('/shop/plus.coc.Index/index', data);
},
/*添加商会会员*/
add(data) {
    return request._post('/shop/plus.coc.Index/add', data);
},
/*修改商会会员*/
edit(data) {
    return request._post('/shop/plus.coc.Index/edit', data);
},
/*删除商会会员*/
del(data) {
    return request._post('/shop/plus.coc.Index/del', data);
},
/*商会会员详情*/
detail(data) {
  return request._post('/shop/plus.coc.Index/detail', data);
},
 // 审核
 passCanel(data) {
  return request._post('/shop/plus.coc.Index/passCanel', data);
},
}
export default CocApi;



// WEBPACK FOOTER //
// ./src/api/coc.js